export enum UrlPathsEnum {
	status = '/status',
	datasources = '/datasources',
	sstnLoggingStyles = 'sstnLoggingStyles',
	dhlLoggingStyles = 'dhlLoggingStyles',
	businessUnits = 'businessUnits',
	externalTransferHeader = 'externalTransferHeader',
	externalTransfer = '/externalTransfer',
	export = 'export',
	import = 'import',
	copyin = 'copyin',
	checkin = 'checkin',
	checkout = 'checkout'
}
